'use client';

import AddAlertIcon from '@mui/icons-material/AddAlert';
import { Box, Button, Typography } from '@mui/material';
import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { type CSSProperties, useState } from 'react';
import type { PromotionalBannerSignUpOptions } from '../PromotionalBanner/types';
import { PromotionalButtonModal } from './PromotionalButtonModal';
import { BUTTON_ENTITY_NAME, BUTTON_SECTION_NAME } from './segment_constants';

type PromotionalButtonProps = {
  isEnabled: boolean;
  signUpOptions?: PromotionalBannerSignUpOptions;
  variant?: 'solo' | 'group';
};

export function PromotionalButton({
  isEnabled,
  signUpOptions,
  variant = 'group',
}: PromotionalButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isEnabled || !signUpOptions) {
    return null;
  }

  const isSolo = variant === 'solo';

  return (
    <>
      <ElementViewed entityName={BUTTON_ENTITY_NAME} sectionName={BUTTON_SECTION_NAME}>
        {({ fireElementInteracted }) => (
          <Box
            sx={{
              display: 'flex',
              pt: 5,
              justifyContent: 'center',
              width: 'var(--pm-btn-width)',
            }}
            style={{ '--pm-btn-width': isSolo ? '100%' : undefined } as CSSProperties}
          >
            <Button
              disableRipple
              disableFocusRipple
              onClick={() => {
                fireElementInteracted('click');
                setIsModalOpen(true);
              }}
              sx={{
                width: { xs: 'var(--pm-btn-w-xs)', md: 'var(--pm-btn-w-md)' },
                borderWidth: '1px',
                borderColor: 'primary.main',
                borderStyle: 'solid',
                backgroundColor: 'white',
                color: 'primary.main',
                padding: 3,
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: '19.5px',
                textTransform: 'uppercase',
                display: 'flex',
                gap: '8px',
                borderRadius: '4px',
                height: '48px',
              }}
              style={
                {
                  '--pm-btn-w-xs': '100%',
                  '--pm-btn-w-md': isSolo ? '40%' : 'fit-content',
                } as CSSProperties
              }
            >
              <AddAlertIcon sx={{ fontSize: '22px' }} />
              <Typography
                style={
                  {
                    '--pm-txt-size-xs': isSolo ? 'block' : 'none',
                    '--pm-txt-size-md': 'block',
                  } as CSSProperties
                }
                sx={{ display: { xs: 'var(--pm-txt-size-xs)', md: 'var(--pm-txt-size-md)' } }}
                variant="textSmall"
              >
                GET RATE ALERTS
              </Typography>
            </Button>
          </Box>
        )}
      </ElementViewed>
      <PromotionalButtonModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        signUpOptions={signUpOptions}
      />
    </>
  );
}
